module.exports = __webpack_public_path__ + "img/2.0.e3dee1b9.png";